import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';

import { Card } from 'sa-ui';
import messages from './reportsMessages';
import * as helpers from './reportHelpers';
import LoadMore from './LoadMore';

import StudentPerformanceSquare from './StudentPerformanceSquare';

import './GradeComparativeAbilitiesTable.scss';

const GradeComparativeAbilitiesTable = (props) => {
  const [limit, setLimit] = useState(props.expanded ? Infinity : props.limit);

  const sortData = (data) => {
    const sortedData = [...data].sort((a, b) => b.percentHits - a.percentHits);
    const topFive = sortedData.slice(0, 3);
    const bottomFive = sortedData.slice(-3);
    return topFive.concat(bottomFive);
  };

  const sortedData = sortData(props.data);

  return (
    <Card className="students-grade-table">
      <div className="mb-4">
        <h5 className="title mt-0 pb-0 d-inline-block">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.hitPercentageAbilitiesPerQuestion)}
        </h5>
      </div>
      <div>
        <table className="default-table">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.notebook)}</th>
              <th>{props.intl.formatMessage(messages.questionComponent)}</th>
              <th>{props.intl.formatMessage(messages.abilities)}</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)} (%)</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.slice(0, 6).map((s, index) => (
              <tr key={index}>
                <td className="font-smaller">{`${s.notebook}`}</td>
                <td className="font-smaller">{`Q${s.position}/${s.curricularComponent}`}</td>
                <td className="btn-abilities font-smaller">
                  {s.contentAbility && s.abilityDescription ? (
                    <OverlayTrigger
                      trigger="hover"
                      key={index}
                      placement="left"
                      overlay={
                        <Popover id="popover-positioned-left">
                          <Popover.Body>{s.abilityDescription}</Popover.Body>
                        </Popover>
                      }
                    >
                      <Button>{s.contentAbility}</Button>
                    </OverlayTrigger>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  <StudentPerformanceSquare
                    percentHits={s.percentHits}
                    color={helpers.getColor(s.percentHits)}
                    size={50}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* {!props.expanded && props.data.length > 10 && (
          <LoadMore onClick={() => setLimit(limit + props.limit)} />
        )} */}
      </div>
    </Card>
  );
};

GradeComparativeAbilitiesTable.propTypes = {};

GradeComparativeAbilitiesTable.defaultProps = {
  data: [],
  limit: 6,
  expanded: false,
};

export default injectIntl(GradeComparativeAbilitiesTable);
